import React from "react";

import DurationInputComponent from './DurationInputComponent';

function DurationRangeComponent({ min, max, Dyn, mode, attributeObj, onChange }) {

    function getLoc(str) {
        return Dyn.loc(str);
    }

    // checking if while converting from categorical to numerical if there is
    // no valid numeric value.
    if (typeof min === "undefined" || typeof min === "undefined") {
        return (
            <div className="tde-numeric-component">
                <div className="tde-m-2 tde-text-error">
                    {getLoc("No valid numeric value for the axis range.")}
                </div>
            </div>
        );
    } else {
        return (
            <div className="tde-flex tde-numeric-range-component">
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{getLoc("Min")}</div>
                    <DurationInputComponent value={min} Dyn={Dyn} subType={mode} attributeObj={attributeObj} onChange={value => onChange([value, max])} />
                </div>
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{getLoc("Max")}</div>
                    <DurationInputComponent value={max}  Dyn={Dyn} subType={mode} attributeObj={attributeObj} onChange={value => onChange([min, value])} />
                </div>
            </div>
        );
    }
}

export default DurationRangeComponent;
